// public/js/modules/filters/traveled-filter.js
// "Travelled" filter: show only assets that moved >=1km within the last 24h.
//
// All the work happens server-side on ingest (asset.lastTraveledAt is stamped
// once a device completes a travel leg — see utils/travel.mjs), so this filter
// is a pure client-side timestamp comparison: zero extra requests.
//
// Toggled via a map control button (see pages/map.js), like clusteringFilter,
// so renderUI() stays empty — the filter only holds its enabled state.
const WINDOW_HOURS = 24;

export function hasTraveledRecently(asset, windowHours = WINDOW_HOURS) {
  if (!asset?.lastTraveledAt) return false;
  const t = new Date(asset.lastTraveledAt).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t <= windowHours * 3600 * 1000;
}

export const traveledFilter = {
  id: 'traveled',
  getDefaultState: () => ({ enabled: false }),

  renderUI() {
    return '';
  },

  apply(assets, state) {
    if (!state?.enabled) return assets;
    return assets.filter((a) => hasTraveledRecently(a));
  },
};
